import React, { useEffect, useState } from "react";

import { Fade, Modal as ModalMUI } from "@mui/material";
import { Typography } from "@mui/material";

import { Close } from "@mui/icons-material"

import styles from "./Modal.module.scss";
import Button from "components/Button/Button";

export default function Modal({
    children,
    title,
    confirmationModal = false,
    onClose = () => { },
    open,
    wide = false,
}) {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);


    useEffect(() => {
        const handleKeyUp = ({ key }) => {
            if (key === "Escape") {
                setConfirmationModalOpen(true);
            }
        };

        open && window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [open]);

    const handleCloseModal = () => {
        if (confirmationModal) {
            setConfirmationModalOpen(true);
            return;
        }
        onClose();
    };
    return (
        <>
            <ModalMUI
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={styles.modal}
                open={open}
            >
                <Fade in={open} className={styles.modal}>
                    <div className={styles.modal}>
                        <div
                            className={`${styles.paper} ${wide ? styles.paperWide : ""}`}
                            style={{ visibility: open ? 'visible' : 'hidden' }}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={100}
                                className={`${styles.title} ${wide ? styles.titleWide : ""}`}
                                style={{
                                    color: title?.toLowerCase().includes("eliminar")
                                        ? "#f00"
                                        : "",
                                }}
                            >
                                {title}
                            </Typography>
                            <hr className={styles.hr} />
                            <Close
                                className={styles.closeButton}
                                onClick={handleCloseModal}
                                role="button"
                                style={{ margin: '0 -18px 0 0' }}
                            />
                            <div className={styles.content}>
                                {children}
                            </div>
                        </div>
                    </div>
                </Fade>
            </ModalMUI>

            {confirmationModal && confirmationModalOpen && (
                <ModalMUI
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    className={styles.confirmationModal}
                    open={open}
                >
                    <Fade in={open} className={styles.modal}>
                        <div className={styles.confirmationModal}>
                            <div className={styles.paper}>
                                ¿Estás seguro que deseás cancelar?
                                <br />
                                Perderás todos los cambios establecidos
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setConfirmationModalOpen(false);
                                        onClose();
                                    }}
                                >
                                    <span>Sí</span>
                                </Button>
                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setConfirmationModalOpen(false);
                                    }}
                                >
                                    <span>No</span>
                                </Button>
                            </div>
                        </div>
                    </Fade>
                </ModalMUI>
            )}
        </>
    );
}
